import { createReducer } from '@reduxjs/toolkit';

import * as editorActions from '../actions/editor.action';
import editorLinkedTextElementsReducer from './editor.linkedTextElements.reducer';

export const initialState = {
  ...editorLinkedTextElementsReducer.initialState,
  zoom: 1,
  canvasRelativeSize: {},
  currentLayer: undefined,
  header: {},
  footer: {},
  pagesOrder: [],
  activePage: undefined
};

const setActivePage = (state, { payload }) => {
  state.activePage = payload;
};

const setPagesOrder = (state, { payload }) => {
  const newOrder = payload;
  const [activePage] = newOrder;

  state.pagesOrder = newOrder;

  if (!state.activePage && activePage) state.activePage = activePage;
};

const setState = prop => (state, { payload }) => {
  state[prop] = payload;
};

const setHeaderSize = (state, { payload }) => {
  const { unit, value } = payload;

  state.header.size = { unit, value };
};

const setFooterSize = (state, { payload }) => {
  const { unit, value } = payload;

  state.footer.size = { unit, value };
};

export default createReducer(initialState, builder => {
  [
    [editorActions.setActivePage, setActivePage],
    [editorActions.setCanvasRelativeSize, setState('canvasRelativeSize')],
    [editorActions.setCurrentLayer, setState('currentLayer')],
    [editorActions.setFooterSize, setFooterSize],
    [editorActions.setHeaderSize, setHeaderSize],
    [editorActions.setPagesOrder, setPagesOrder],
    [editorActions.setZoom, setState('zoom')],
    ...editorLinkedTextElementsReducer.cases
  ].forEach(([action, reducerCallback]) => builder.addCase(action, reducerCallback));
});
